import { render, staticRenderFns } from "./store_data_ykf.vue?vue&type=template&id=1d8480c7&scoped=true&"
import script from "./store_data_ykf.vue?vue&type=script&lang=js&"
export * from "./store_data_ykf.vue?vue&type=script&lang=js&"
import style0 from "./store_data_ykf.vue?vue&type=style&index=0&id=1d8480c7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d8480c7",
  null
  
)

export default component.exports